import { useState } from "react";
import {
  FaWhatsapp,
  FaInstagram,
  FaYoutube,
  FaTelegram,
  FaFacebook,
  FaChevronDown, // Icon for collapsing
  FaChevronUp,   // Icon for expanding
} from "react-icons/fa";

export default function FloatingChat() {
  // Set initial state to false so the icons are hidden by default
  const [isVisible, setIsVisible] = useState(true);

  // Social media links
  const whatsapp = "https://whatsapp.com/channel/0029VaAIY8pFsn0dYJCUZo34";
  const instagram = "https://www.instagram.com/studyweaponsbyreja?igsh=MmR6ZDMxdGFiYnc4";
  const youtube = "https://youtube.com/@studyweaponsbyreja?si=jNVDp9SG-DvnNLSY";
  const telegram = "https://t.me/studyweaponsbyreja"; // Add your Telegram link
  const facebook = "https://www.facebook.com/share/16uiPs117e/"; // Add your Facebook link

  const toggleVisibility = () => {
    setIsVisible(!isVisible);
  };

  return (
    <div className="fixed right-4 bottom-6 flex flex-col items-end gap-3 z-50">
      {/* Toggle Button - Size changed to w-12 h-12 */}
      <button
        onClick={toggleVisibility}
        className="w-12 h-12 flex items-center justify-center rounded-full bg-blue-600 shadow-lg text-white text-2xl"
        aria-label={isVisible ? "Collapse social links" : "Expand social links"}
      >
        {/* Change icon based on visibility state */}
        {isVisible ? <FaChevronDown /> : <FaChevronUp />}
      </button>

      {/* Conditionally render social media icons */}
      {isVisible && (
        <>
          {/* Facebook Icon */}
          <a href={facebook} target="_blank" rel="noopener noreferrer" aria-label="Facebook">
            <div className="w-12 h-12 flex items-center justify-center rounded-full bg-blue-800 shadow-lg text-white text-2xl">
              <FaFacebook />
            </div>
          </a>

          {/* Telegram Icon */}
          <a href={telegram} target="_blank" rel="noopener noreferrer" aria-label="Telegram">
            <div className="w-12 h-12 flex items-center justify-center rounded-full bg-sky-500 shadow-lg text-white text-2xl">
              <FaTelegram />
            </div>
          </a>

          {/* YouTube Icon */}
          <a href={youtube} target="_blank" rel="noopener noreferrer" aria-label="YouTube">
            <div className="w-12 h-12 flex items-center justify-center rounded-full bg-red-600 shadow-lg text-white text-2xl">
              <FaYoutube />
            </div>
          </a>

          {/* Instagram Icon */}
          <a href={instagram} target="_blank" rel="noopener noreferrer" aria-label="Instagram">
            <div className="w-12 h-12 flex items-center justify-center rounded-full bg-pink-600 shadow-lg text-white text-2xl">
              <FaInstagram />
            </div>
          </a>

          {/* WhatsApp Icon */}
          <a href={whatsapp} target="_blank" rel="noopener noreferrer" aria-label="WhatsApp">
            <div className="w-12 h-12 flex items-center justify-center rounded-full bg-green-600 shadow-lg text-white text-2xl">
              <FaWhatsapp />
            </div>
          </a>
        </>
      )}
    </div>
  );
}